import React from "react";

import Table from "@material-ui/core/Table";
import TableHead from "@material-ui/core/TableHead";
import TableBody from "@material-ui/core/TableBody";

import { useSelector, useDispatch } from "react-redux";

import { Box, Typography } from "@material-ui/core";
import Pagination from "@material-ui/lab/Pagination";
import { animateScroll as scroll } from "react-scroll";

import PointShopTableHading from "./PointShotTableHading";
import PointShopTableItem from "./PointShopTableItem";

import NewsRequests from "services/news";

const PointShopTable = ({ searchMode, searchInput }) => {
  const { prizes, prizesTotalPage, prizesCurrentPage } = useSelector(
    ({ news }) => news
  );
  const dispatch = useDispatch();

  const handleChangePagination = (_, value) => {
    if (searchMode) {
      dispatch(NewsRequests.getAllPrizes(value, searchInput));
    } else {
      dispatch(NewsRequests.getAllPrizes(value));
    }
    scroll.scrollToTop();
  };

  return (
    <div className="Cmt-table-responsive">
      {prizes && prizes.length === 0 ? (
        <Box
          display={"flex"}
          justifyContent={"center"}
          paddingTop={"30px"}
          paddingBottom={"20px"}
        >
          <Typography variant="h3">موردی برای نمایش وجود ندارد</Typography>
        </Box>
      ) : (
        <Table>
          <TableHead>
            <PointShopTableHading />
          </TableHead>
          <TableBody>
            {prizes.map((item) => (
              <PointShopTableItem data={item} key={item._id} />
            ))}
          </TableBody>
        </Table>
      )}
      {prizes.length !== 0 ? (
        <Box display={"flex"} justifyContent={"center"} marginTop={"20px"}>
          <Pagination
            count={prizesTotalPage}
            color="primary"
            page={prizesCurrentPage}
            onChange={handleChangePagination}
          />
        </Box>
      ) : null}
    </div>
  );
};

export default PointShopTable;
